import React from "react";
import GIELink from "../GIELink/GIELink";

class GIEFooterDown extends React.Component {
  render() {
    const currentYear = new Date().getFullYear();
    return (
      <div className="footer-down-container">
        <span>Tous droits réservés GIE {currentYear}</span>
        <div>
          <div className="d-flex gap-2 d-flex justify-content-center">
            <GIELink className="color-white" labelClass="text-decoration-none" href="https://gie-sa.fr/mentions-legales/">
              Mentions légales
            </GIELink>
            <GIELink className="color-white" labelClass="text-decoration-none" href="https://gie-sa.fr/politique-de-confidentialite">
              Confidentialité
            </GIELink>
            <GIELink className="color-white" labelClass="text-decoration-none" href="https://gie-sa.fr/politique-cookies">
              Cookies
            </GIELink>
            <GIELink className="color-white" labelClass="text-decoration-none" href="https://gie-sa.fr/reclamation/">
              Réclamation
            </GIELink>
            <GIELink className="color-white" labelClass="text-decoration-none" href="https://gie-sa.fr/conditions-generales-de-vente/">
              CGV
            </GIELink>
            <GIELink className="color-white" labelClass="text-decoration-none" href="javascript:void(0)">
              Gestion des cookies
            </GIELink>
          </div>
        </div>
        <div style={{width: "255px"}}>
        </div>
      </div>
    );
  }
}

export default GIEFooterDown;
